import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=2f30711b&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"
import style0 from "./Tree.vue?vue&type=style&index=0&id=2f30711b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f30711b",
  null
  
)

export default component.exports